@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (lijfrentePremiesAOV.length > 0) {
      <div formArrayName="lijfrentePremiesAOV">
        @for (item of lijfrentePremiesAOV.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving AOV-verzekering' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijvingANW"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Polisnummer' : ''"
                                              class="custom-input-250"
                                              formControlName="polisnummer"
                                              id="polisnummerANW"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control (change)="saveForm()"
                                                [decimals]="0"
                                                [label]="i === 0 ? 'Bedrag' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   class="delete"
                                   icon="trash"
                                   iconType="light"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus"
                       type="link">Premie AOV toevoegen
  </snelstart-ui-button>
}
